import { render, staticRenderFns } from "./AlertsInfoEdit.vue?vue&type=template&id=86e9839e&"
import script from "./AlertsInfoEdit.vue?vue&type=script&lang=js&"
export * from "./AlertsInfoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports